import providers from './providers';

const auth = ({ to, next, router }, userToken) => {
  const rules = to.meta.middleware.rules;

  if (!userToken) {
    providers.setTitle(to);

    return next({ name: 'auth' });
  }

  const userRole = JSON.parse(window.atob(userToken.split('.')[1].replace('-', '+').replace('_', '/'))).role_name;

  if (rules.includes(userRole)) {
    providers.setTitle(to);

    return next();
  } else {
    if (to.name !== 'welcome_page') {
      return next('/');
    }

    providers.setTitle(to);

    return next();
  }
};

export default auth;
